/**
 * Non-component pieces of the stat tile shared with the add-tile dialog's
 * live stat preview (visual parity). Kept out of StatTileView.tsx so that
 * file stays component-only (react-refresh).
 */
import type { StatTile } from '../../types/dashboardTypes';
import type { ThresholdSeverity } from '../../utils/thresholdEval';
import type { StatSparklinePoint } from './StatSparkline';

export const SEVERITY_TEXT: Record<ThresholdSeverity, string> = {
  none: 'text-foreground',
  warning: 'text-warning',
  critical: 'text-red-500',
};

export function buildSparklinePoints(
  rows: Record<string, unknown>[] | undefined,
  sparkline: StatTile['sparkline'],
): StatSparklinePoint[] {
  if (!sparkline || !rows) return [];
  const points: StatSparklinePoint[] = [];
  for (const r of rows) {
    const raw = r[sparkline.valueColumn];
    const num = typeof raw === 'number' ? raw : Number(raw);
    if (raw === null || raw === undefined || !Number.isFinite(num)) continue;
    points.push({ time: r[sparkline.timeColumn], value: num });
  }
  return points;
}
